<template>
    <v-content>
      <v-container fluid fill-height ma-0 pa-0 id="page-container">
        <v-layout>
            <sidebar />
            <v-flex text-xs-center id="page-content">
                <router-view />
            </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
export default {
  name: 'ContentLayout'

}
</script>

<style lang="scss" scoped>
</style>